var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute w-full bottom-0"},[_c('hr'),_c('div',{staticClass:"p-4 flex justify-center"},[_c('router-link',{staticClass:"btn plain flex items-center",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }